import { render, staticRenderFns } from "./listDk.vue?vue&type=template&id=439a619d&scoped=true&"
import script from "./listDk.vue?vue&type=script&lang=js&"
export * from "./listDk.vue?vue&type=script&lang=js&"
import style0 from "./listDk.vue?vue&type=style&index=0&id=439a619d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439a619d",
  null
  
)

export default component.exports